import React from 'react';
import styles from './FormBtn.module.css';

export const FormBtn = ({text, underText, active, onClick, style}) => {
	return (
		<div style={style} onClick={onClick} className={`${styles.main} ${active && styles.btnActive}`}>
			{text}
			{
				underText && <p className={styles.underText}>{underText}</p>
			}
			
		</div>
	);
};
